module.exports = __webpack_public_path__ + "static/img/device-mockup02-03@t.57a73bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/device-mockup02-03@t.png
// module id = yE+K
// module chunks = 0